import merge from 'lodash/merge';
import * as actions from './types';
import service from './service';

const fetchList = (search, dispatch) =>
  service
    .fetchList(search)
    .then(response => dispatch({ type: actions.FETCH_LIST, data: response.data }));

const getNewSearch = (search, getState) => {
  const { form, sort, page } = getState().HomeSurvey;
  return merge({}, { form, sort, page }, search);
};

const creators = {
  searchFormSubmit: form =>
    async (dispatch, getState) => {
      dispatch({ type: actions.SEARCH_FORM_SUBMIT, form });
      return fetchList(getNewSearch({ form, page: 0 }, getState), dispatch);
    },
};

export default creators;
